var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgJs = function SvgJs(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "M3 3h42v42H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5 37.931 3.092-2.046c.243.762 1.777 2.57 3.716 2.57 1.938 0 2.838-1.059 2.838-1.76 0-1.913-1.98-2.588-2.93-2.912-.155-.053-.283-.096-.37-.134a5.55 5.55 0 0 0-.2-.079c-1.056-.404-4.957-1.894-4.957-6.214 0-4.759 4.592-5.306 5.63-5.306.68 0 3.946.083 5.573 3.14l-3 2.094c-.657-1.332-1.75-1.772-2.423-1.772-1.661 0-2.008 1.218-2.008 1.772 0 1.556 1.806 2.254 3.33 2.842.399.154.778.301 1.101.454 1.662.785 4.108 2.07 4.108 6.114C42 38.72 40.3 42 36.023 42c-5.746 0-7.27-3.45-7.523-4.069ZM13.5 38.338l3.223-2.045c.253.76 1.234 2.164 2.658 2.164s2.152-1.463 2.152-2.164V22.5h3.964v13.793c.064 1.902-.99 5.707-5.647 5.707-4.282 0-6.061-2.544-6.35-3.662Z",
    fill: "#3E3E3E"
  })));
};

export default SvgJs;